import { render, staticRenderFns } from "./ProdImg.vue?vue&type=template&id=faca4a0c&scoped=true"
import script from "./ProdImg.vue?vue&type=script&lang=js"
export * from "./ProdImg.vue?vue&type=script&lang=js"
import style0 from "./ProdImg.vue?vue&type=style&index=0&id=faca4a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca4a0c",
  null
  
)

export default component.exports